<template>
  <div class="wrap">
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt" :class="{'fa-spin': isRefreshing}"></i>
        </button>
        <slot name="buttons"></slot>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              width="80"
          ></el-table-column>
          <el-table-column
              label="Name"
              prop="model.name"
              min-width="150"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="model.brand.title"
              label="Brand"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="model.expiry_period"
              label="Expiry Period"
              :formatter="formatExpiryPeriod"
              min-width="80"
          ></el-table-column>
          <el-table-column
              label="Actions"
              v-slot="{row}"
              align="center"
              header-align="center"
          >
            <actions-column :row="row" @toggle="onToggle"></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import TableWithPagination from "../../../table-with-pagination";
import {addQueryParams} from "../../../../libs/url";
import ActionsColumn from './actions-column';

export default {
  extends: TableWithPagination,

  components: {
    ActionsColumn,
  },

  data() {
    return {
      search: null,
      filters: {},
      conversationId: null,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search: function (value) {
      if (value) {
        this.filters = _.assign({}, this.filters, {search: value});
      } else {
        this.filters = _.omit(this.filters, ['search']);
      }
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @return {string}
     */
    formatExpiryPeriod(row, column, cellValue, index) {
      return _.isFinite(cellValue)
          ? moment.duration(cellValue, 'seconds').humanize()
          : '';
    },

    /**
     * @param {object} row
     */
    onToggle({row: {toggle_url: url, model: {id}}}) {
      const form = {
        conversation_id: this.conversationId,
        send_list_id: id,
      };

      const index = _.findIndex(this.items, val => val.model.id === id);
      const item = _.get(this.items, [index]);
      this.items.splice(index, 1, _.assign({}, item, {is_bound: !item.is_bound}));

      return axios.post(url, form)
          .then(this.toggleSuccess)
          .catch(err => {
            this.items.splice(index, 1, item);
            this.handleErrorResponse(err);
          });
    },

    /**
     * @param {object} data
     * @return {undefined}
     */
    toggleSuccess({data: {message}}) {
      _.isString(message) && this.$message.success(message);
      this.$emit('change');
    },

    /**
     * @param {Array} items
     * @param {Number} conversationId
     * @param {Number} total
     * @param {Number} currentPage
     * @param {Number} pageSize
     */
    onLoadSuccess({items, meta: {conversation_id: conversationId, current_page: currentPage, per_page: pageSize, total}}) {
      this.items = items;
      this.total = total;
      this.currentPage = currentPage;
      this.pageSize = pageSize;
      this.conversationId = conversationId;
    },

    /**
     * @param data
     * @param status
     * @return {boolean}
     */
    handleErrorResponse({response: {data, status}}) {
      const {message} = data || {};
      this.$message.error(message);
    },
  },
}
</script>
